import { EditableGridPage } from "@repo/ui";
import { useCallback } from "react";

import { useTrainingQueries } from "../../api/trainingApi";
import {
	TrainerCertificationProvider,
	useRepContext,
	useTrainerCertificationContext,
} from "../../contexts/editableItemContext";
import { usePermissionsCheck } from "../../helpers/permissions";
import { useEntityId, useUpdateRoute } from "../../helpers/urlHooks";
import { ITrainerCertification } from "../../models/MVCStateSpecificTraining";
import TrainerCertificationEditorDynamic from "./editor";
import TrainerCertificationGridBasic from "./grid";
import { Props } from "./types";

function TrainerCertification(props: Props) {
	return (
		<TrainerCertificationProvider>
			<TrainerCertificationInternal {...props} />
		</TrainerCertificationProvider>
	);
}

const TrainerCertificationInternal = (props: Props) => {
	const { repId } = useRepContext();
	const { overwriteItem, pendingChanges } = useTrainerCertificationContext();

	const { useTrainerCertificationsQuery } = useTrainingQueries();
	const { data, loaded } = useTrainerCertificationsQuery();

	const entityId = useEntityId();
	const updateRoute = useUpdateRoute();

	const { fullAPReadOnly } = usePermissionsCheck();

	const handleOpen = (item: ITrainerCertification) => {
		overwriteItem(item);
	};

	const newItem = useCallback(() => {
		overwriteItem({} as ITrainerCertification);
	}, [overwriteItem, repId]);

	return (
		<EditableGridPage<ITrainerCertification>
			id="TrainerCertificationsContainer"
			items={data}
			keyProperty="id"
			Editor={TrainerCertificationEditorDynamic}
			Grid={TrainerCertificationGridBasic}
			openItem={handleOpen}
			pendingChanges={pendingChanges}
			newItem={newItem}
			itemsLoaded={loaded}
			readOnly={props.readOnly}
			entityId={entityId}
			updateRoute={updateRoute}
			fullReadOnly={fullAPReadOnly}
		/>
	);
};

export default TrainerCertification;
